import { mapActions, mapGetters, mapMutations } from 'vuex'
import general from '../general/index.vue'

export default {
  name: 'setting-stores-dialog-view',
  data () {
    return {
      dialog: true,
      activeTab: 'general',
    }
  },
  components: {
    general
  },
  watch: {
    openDialogView () {
      this.dialog = this.openDialogView
    }
  },
  computed: {
    ...mapGetters({
      currentItem: 'settingStores/currentItem',
      openDialogView: 'settingStores/openDialogView',
      basicLocales: 'setting/basicLocales',
      editId: 'settingStores/editId',
	  isLoading: 'settingStores/isLoading'
    }),
    tabs () {
      return [
        {
          name: 'General',
          slug: 'general',
          id: 1
        }
      ]
    }
  },
  created () {
    if (!this.basicLocales.length) {
      this.fetchBasicLocales()
    }
    if (this.editId) {
      this.fetchItem()
    }
  },
  methods: {
    ...mapActions({
      fetchItem: 'settingStores/GET_LIST_ITEM',
      fetchBasicLocales: 'setting/GET_BASIC_LOCALES'
    }),
    ...mapMutations({
      changeDialogView: 'settingStores/CHANGE_DIALOG_VIEW',
      changeEditId: 'settingStores/CHANGE_EDIT_ID',
      setContent: 'settingStores/SET_ITEM'
    }),
    changeCloseDialog () {
      this.dialog = false
      this.changeDialogView(false)
      this.changeEditId('')
    },

	save(){
	  this.$refs['general'].$emit('event-save');
	}
  },
  destroyed () {
    this.setContent(null)
  }
}
